import { render, staticRenderFns } from "./CustomRuleBuilder.vue?vue&type=template&id=4c283cb2"
import script from "./CustomRuleBuilder.vue?vue&type=script&lang=js"
export * from "./CustomRuleBuilder.vue?vue&type=script&lang=js"
import style0 from "./CustomRuleBuilder.vue?vue&type=style&index=0&id=4c283cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports